export const API_HOST = process.env.API_HOST || 'http://localhost:5000';
export const SHOPIFY_API_KEY = process.env.SHOPIFY_API_KEY;
